<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { PhotographyContributionDetail } from '@/components/widgets'

export default {
    name: 'photographyContributionDetail',
    components: { WPhotographyContributionDetail: PhotographyContributionDetail },
    props: {
        type: {
            type: Number,
            default: 8
        },
        value: Boolean,
        showOperation: Boolean,
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            info: {},
            activeName: 'works',
            detailDrawer: false
        };
    },
    methods: {
        init() {
            this.photoworkReviewInfo()
            this.reviewreason()
        },
        async reviewreason() {
            let data = await this.api.reviewreason({ limit: 100, type: this.type })
            this.rejectReasonList = data.data
        },
        async photoworkReviewInfo() {
            this.info = await this.api.photoworkReviewInfo({ type: this.type, ...this.params })
        },
        operationSuccess() {
            this.closeDrawer()
        },
        closeDrawer() {
            this.$emit('input', false)
        }
    },
    watch: {
        value(val) {
            this.detailDrawer = val

            if(val) {
                this.init()
            }
        }
    }
};
</script>
